import { render, staticRenderFns } from "./EmployeeITRQ.vue?vue&type=template&id=20541847&"
import script from "./EmployeeITRQ.vue?vue&type=script&lang=ts&"
export * from "./EmployeeITRQ.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeITRQ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports